<template>
    <div
        class="relative h-[66px] w-full overflow-hidden rounded-xl sms-ai-loading-overlay"
        data-testid="sms-ai-loading-overlay"
    >
        <ai-draft-loading-border testid-prefix="sms-ai-loading" />

        <div class="absolute left-4 top-2.5 flex items-center">
            <span class="flex items-center gap-1 text-[#0000FF] font-semibold">
                <icon data-testid="sms-ai-loading-icon" name="regular/sparkles" />
                <span class="animate-pulse" data-testid="sms-ai-loading-label">
                    {{ $t('smsCommunication.aiDraft.generatingDraft') }}
                    <span aria-hidden="true" class="ai-draft-loading-dots" />
                </span>
            </span>
        </div>

        <button
            class="sms-ai-stop-button absolute right-[11px] top-[29px] flex h-[24px] w-[24px] shrink-0 items-center justify-center text-black hover:text-gray-600"
            :aria-label="$t('smsCommunication.aiDraft.stopGeneration')"
            data-testid="sms-ai-stop-button"
            type="button"
            @click="$emit('stop')"
        >
            <icon class="h-[24px] w-[24px]" data-testid="sms-ai-stop-icon" name="regular/ai-stop" />
        </button>

        <div
            class="pointer-events-none absolute left-[12px] right-[12px] top-[32px] flex flex-col gap-[5px]"
            data-testid="sms-ai-skeleton-preview"
        >
            <skeleton-loading class="h-[9px] w-[68%]" round />
            <skeleton-loading class="h-[9px] w-[85%]" round />
        </div>
    </div>
</template>

<script setup lang="ts">
    import AiDraftLoadingBorder from '@/components/aiDraft/loading/AiDraftLoadingBorder.vue';
    import SkeletonLoading from '@/components/loading/SkeletonLoading.vue';
    import '@/components/aiDraft/loading/aiDraftLoadingDots.css';

    defineEmits<{
        stop: [];
    }>();
</script>

<style scoped>
    .sms-ai-loading-overlay {
        background: #fff;
    }

    /* stroke-width 0.5 -> ~1px ring at 24px, matches Figma */
    .sms-ai-stop-button :deep(.svg-icon path) {
        stroke-width: 0.5;
    }
</style>
